module.exports = __webpack_public_path__ + "static/media/yelpcamp.79c1c5b3.png";